import * as tslib_1 from "tslib";
import { Apollo } from 'apollo-angular';
import { ARCHIVE_LOCATION_ENVIRONMENT_MUTATION, UNARCHIVE_LOCATION_ENVIRONMENT_MUTATION } from './location-environment.query';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
var ArchiveLocationEnvironmentApi = /** @class */ (function () {
    function ArchiveLocationEnvironmentApi(apollo) {
        this.apollo = apollo;
    }
    ArchiveLocationEnvironmentApi.prototype.archive = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apollo.mutate({
                            mutation: ARCHIVE_LOCATION_ENVIRONMENT_MUTATION,
                            variables: { input: params },
                        }).toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ArchiveLocationEnvironmentApi.prototype.unarchive = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apollo.mutate({
                            mutation: UNARCHIVE_LOCATION_ENVIRONMENT_MUTATION,
                            variables: { input: params },
                        }).toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ArchiveLocationEnvironmentApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ArchiveLocationEnvironmentApi_Factory() { return new ArchiveLocationEnvironmentApi(i0.ɵɵinject(i1.Apollo)); }, token: ArchiveLocationEnvironmentApi, providedIn: "root" });
    return ArchiveLocationEnvironmentApi;
}());
export { ArchiveLocationEnvironmentApi };
